import { render } from "./CustomsDeclarationSectionFour.vue?vue&type=template&id=3487e1f1&scoped=true"
import script from "./CustomsDeclarationSectionFour.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationSectionFour.vue?vue&type=script&lang=js"

import "./CustomsDeclarationSectionFour.vue?vue&type=style&index=0&id=3487e1f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3487e1f1"]])

export default __exports__